<template>
  <div id="transactionResult">
    <!--   成功-->
    <div class="Grid77400FB8" v-if="resultState">
      <div class="Grid085E2874">
        <img
          :src="resultSuccess"
          class="imgF18DCF96"
        />
        <span class="text4BFD5DBE">{{$t('label.label114')}}</span>
        <span class="text4BFD5DBF">{{ccy}} {{$commafy(balance)}}</span>
        <!--  v-if="proInfo.prodType === 'FP01060005'" -->
        <div v-if="proInfo.prodClass !== 'FP101'">
          <md-steps
            direction="vertical"
            :steps="steps"
            :current="1.5"
            vertical-adaptive
          >
            <template slot="reached">
              <md-icon name="success" ></md-icon>
            </template>
          </md-steps>
        </div>
      </div>
    </div>
    <!--   失败  -->
    <div class="Grid77400FB8" v-else>
      <div class="Grid085E2874">
        <img
          :src="resultFail"
          class="imgF18DCF96"
        />
<!--        <span class="text4BFD5DBE"> {{resultText}}{{$t('label.label56')}}({{$route.params.err.msg}})</span>-->
        <span class="text4BFD5DBE">{{$t('label.label113')}}({{msg}})</span>
      </div>
    </div>
    <div class="Grid7ECC28FE">
      <md-button :type="'primary'" :round="true" @click="toHomePage">{{$t('btn.btn4')}}</md-button>
    </div>
<!--    <div class="dialogArea">-->
<!--      <md-dialog-->
<!--        v-model="showDialog"-->
<!--        :closable="false"-->
<!--        :mask-closable="true"-->
<!--        :btns="buttons"-->
<!--      >-->
<!--        <div class="iconArea">-->

<!--        </div>-->
<!--        <div class="textArea">-->
<!--          {{$t('label.label215')}}-->
<!--        </div>-->
<!--      </md-dialog>-->
<!--    </div>-->
    <md-landscape v-model="showDialogdecimal" transition="md-bounce">
      <img :src="backImg">
    </md-landscape>
  </div>
</template>
<script>
import { Button, Steps, Icon, Dialog, Landscape, Toast } from '@gidc/mobile'
import { PRODACCTINFO, CUSSOURSE, SENDSDSMS } from '../../api/smartdeposit'
import { mapGetters } from 'vuex'
import backImg0 from '../../assets/images/result.png'
// import backImg1 from '../../assets/images/result.png'
// import backImg2 from '../../assets/images/result.png'
export default {
  name: 'transactionResult',
  components: {
    [Button.name]: Button,
    [Steps.name]: Steps,
    [Icon.name]: Icon,
    [Dialog.name]: Dialog,
    [Landscape.name]: Landscape
  },
  computed: {
    ...mapGetters([
      'RnInfo',
      'proInfo',
      'proInfoDetails'
    ])
  },
  data () {
    return {
      resultState: true,
      resultSuccess: require('@/assets/images/resultsSuccessful.png'),
      resultFail: require('@/assets/images/resultsFailure.png'),
      steps: [
        {
          name: this.$t('label.label115'),
          text: ''
        },
        {
          name: this.$t('label.label116'),
          text: ''
        },
        {
          name: this.$t('label.label117'),
          text: ''
        }
      ],
      baseAcctNo: '',
      ccy: '',
      balance: '',
      msg: '',
      showDialog: false,
      buttons: [
        {
          text: this.$t('btn.btn9')
        }
      ],
      backImg: '',
      showDialogdecimal: false
    }
  },
  methods: {
    formatDate (dateStr) {
      const yy = dateStr.substr(0, 4)
      const mm = dateStr.substr(4, 2)
      const dd = dateStr.substr(6, 2)
      return yy + '-' + mm + '-' + dd
    },
    toHomePage () {
      this.$router.push('myPosition')
    },
    getProTranInfo () {
      const params = {
        baseAcctNo: this.baseAcctNo
      }
      this.$remote.post(PRODACCTINFO + '?_locale=' + this.$exchangeLang(this.RnInfo.language), params, { headers: { _token_name: this.RnInfo.token, 'x-i18n': this.$exchangeLang(this.RnInfo.language) } })
        .then(res => {
          this.ccy = res.list[0].ccy
          this.balance = res.list[0].balance
          this.acctMaturityDate = res.list[0].acctMaturityDate
          this.acctOpenDate = res.list[0].acctOpenDate
          const startDate = this.acctOpenDate.slice(0, 4) + '-' + this.acctOpenDate.slice(4, 6) + '-' + this.acctOpenDate.slice(-2)
          const endDate = this.acctMaturityDate.slice(0, 4) + '-' + this.acctMaturityDate.slice(4, 6) + '-' + this.acctMaturityDate.slice(-2)
          console.log(startDate)
          console.log(endDate)
          const dateResult = new Date(endDate).getTime() - new Date(startDate).getTime()
          console.log(dateResult)
          const list = [
            {
              name: this.$t('label.label115'),
              text: this.formatDate(this.acctOpenDate)
            },
            {
              name: this.$t('label.label116'),
              text: this.formatDate(this.acctOpenDate)
            },
            {
              name: this.$t('label.label117'),
              text: this.formatDate(this.acctMaturityDate) + ' ' + this.$getFormat(this.$t('label.label225'), dateResult / (24 * 60 * 60 * 1000))
            }
          ]
          this.steps = list
          this.customerPermission()
        })
        .catch(err => {
          console.log(err)
          this.customerPermission()
        })
    },
    clearStore () {
      this.$store.commit('headerInfo', '')
      this.$store.commit('buyProInfo', '')
      this.$store.commit('prodClass', '')
      this.$store.commit('proInfo', '')
      this.$store.commit('proInfoDetails', '')
    },
    customerPermission () {
      this.$remote.post(CUSSOURSE + '?_locale=' + this.$exchangeLang(this.RnInfo.language), {}, { headers: { _token_name: this.RnInfo.token, 'x-i18n': this.$exchangeLang(this.RnInfo.language) } })
        .then(res => {
          console.log(res)
          console.log(this.proInfo.prodClass)
          if (res.source && res.source === '5' && this.proInfo.prodClass === 'FP102') {
            this.showDialogdecimal = true
            this.postMessageToCustomer()
          } else {
            Toast.hide()
          }
          this.clearStore()
        })
        .catch(err => {
          this.clearStore()
          console.log(err)
        })
    },
    postMessageToCustomer () {
      const params = {
        businessCode: 'mobilebanking.notification.smartdeposit'
      }
      this.$remote.post(SENDSDSMS + '?_locale=' + this.$exchangeLang(this.RnInfo.language), params, { headers: { _token_name: this.RnInfo.token, 'x-i18n': this.$exchangeLang(this.RnInfo.language) } })
        .then(res => {
          Toast.hide()
        })
        .catch(err => {
          console.log(err)
        })
    },
    setImage () {
      if (this.$i18n.locale === 'zh') {
        return backImg0
      } else if (this.$i18n.locale === 'tc') {
        return backImg0
      } if (this.$i18n.locale === 'en') {
        return backImg0
      }
    }
  },
  created () {
    this.resultState = this.$route.params.status
    this.$route.meta.result = this.$route.params.status
    this.msg = this.$route.params.msg
    this.baseAcctNo = this.$route.params.baseAcctNo
    this.backImg = this.setImage()
    if (this.resultState) {
      this.getProTranInfo()
    }
  }
}
</script>
<style lang="stylus">
  #transactionResult{

    .md-steps{
      position relative
      height 6.15rem
      left -1.0rem
      .step-wrapper{
        .text-wrapper{
          .name{
            white-space nowrap
            height .48rem
            font-size .34rem
            font-weight 400
            color #1677FF
            line-height .48rem
          }
          .desc{
            white-space nowrap
            height .42rem
            font-size .3rem
            font-weight 400
            color #999999
            line-height .42rem
          }
        }
      }
    }
    .md-button-content{
      font-size .4rem
    }
  }
  .md-toast-text{
    white-space normal
    text-align .28rem
    color #999
   }
  .md-dialog-body{
    padding 0
    .iconArea{
      height 2rem
      background-color #2f86f6
    }
    .textArea{
      padding .3rem
      text-align .28rem
      line-height .4rem
    }
  }
</style>
<style lang="stylus" scoped>
  #transactionResult {
    .Grid77400FB8 {
      padding .88rem 0 0
      .Grid085E2874 {
        display flex
        flex-direction column
        justify-content center
        align-items center
        .imgF18DCF96 {
          width 1.5rem
          height 1.5rem
          display block
        }
        .text4BFD5DBE {
          padding-top .36rem
          padding-bottom .36rem
          font-size .32rem
          text-align center
          color #0C0C0C
          font-weight 400
          line-height .45rem
        }
        .text4BFD5DBF {
          font-size .32rem
          text-align center
          font-weight 600
          color #2B80F4
          line-height .45rem
        }
      }
    }
    .Grid7ECC28FE {
      display flex
      padding 0 .3rem .3rem
    }
  }
</style>
